import { ERegionCode, IAutoRegionConfig } from '../../../interfaces';
import defaultRegionConfig from '../../regionConfigs/defaultRegionConfig';
import enabledAutoRegions from '../../regionConfigs/enabledAutoRegions';
import * as regionConfigs from '../../regionConfigs/regions';

export function getRegionConfig(regionCode: ERegionCode) {
  if (!regionCode) {
    throw new Error('Region code is missing in factory options.');
  }

  if (!enabledAutoRegions.includes(regionCode)) {
    throw new Error(
      `Region code [${regionCode}] is not currently supported in this factory.`
    );
  }

  const regionConfig = (regionConfigs as Record<string, IAutoRegionConfig>)?.[
    regionCode
  ];
  return regionConfig || defaultRegionConfig;
}
